import { useEffect, useState } from '@wordpress/element';
import { Icon,ColorPalette, __experimentalGrid as Grid, __experimentalVStack as VStack,
  __experimentalText as Text, __experimentalUnitControl as UnitControl, 
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';
import { check,shadow } from '@wordpress/icons';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { brush } from '@wordpress/icons';

export const VayuBlocksDropShadowPopup = ({  onChange,label,dropShadow,shadowValueChange} ) => {

  const deviceView  = VayuBlocksDevice();
  const elementValue = dropShadow?.value?.[deviceView]?.elements;
  const [firstTablet, setFirstTablet] = useState(false);
  const [firstDesktop, setFirstDesktop] = useState(false);
  const [ isInset, setIsInset ] = useState( elementValue?.inset?? "outset");
  const [ color, setColor ] = useState ( elementValue?.color ?? "#a299ff");
  const [ xpostion, setXPostion ] = useState (elementValue?.offsetX?? "0px" ) 
  const [ ypostion, setYPostion ] = useState ( elementValue?.offsetY?? "0px"); 
  const [ blur, setBlur ] = useState ( elementValue?.blur?? "5px"); 
  const [ spread, setSpread ] = useState ( elementValue?.spread?? "0px"); 
  const [elevationCheck, setElevationCheck] = useState(elementValue?.elevation?? "none");
  const [ boxShadow, setBoxShadow ] = useState(dropShadow.value);
  const [ fixBoxShadowValue, setFixBoxShadowValue] = useState(dropShadow?.value?.[deviceView]?.css);

  useEffect(() => {
    handelDropShadowAttributes({
    css :`${isInset === 'inset' ? 'inset ' : ''}${xpostion} ${ypostion} ${blur} ${spread} ${color}`,
    elements : {inset:isInset,color:color,offsetX:xpostion,offsetY:ypostion,blur:blur,spread:spread,
      elevation:elevationCheck
    }
  });
  },[isInset,xpostion,ypostion,blur,spread,color,elevationCheck])

  useEffect(() => {
    handelShadowValueChanges();
  },[isInset,fixBoxShadowValue])
         
  const handelDropShadowAttributes = (shadowValue) => {
    setBoxShadow(shadowValue);
    if(isInset==='outset'){
      const validSpread = parseInt(spread, 10) > 7 ? "7px" : spread;
      const validYpostion = parseInt(ypostion, 10) > 4 ? "4px" : ypostion;
      const validXpostion = parseInt(xpostion, 10) > 4 ? "4px" : xpostion;
      const validBlur = parseInt(blur, 10) > 12 ? "12px" : blur;
      setFixBoxShadowValue(`${validXpostion} ${validYpostion} ${validBlur} ${validSpread} ${color}`);
    }else{
      setFixBoxShadowValue(shadowValue?.css);
    }

    const isFirstRun = dropShadow?.value?.[deviceView] === undefined;
    const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

    let updatedAttributes = { ...dropShadow.value };
  
    if (deviceView === 'Desktop') {
      if (isFirstRun || firstDesktop) {
          updatedAttributes = { Desktop: shadowValue, Tablet: shadowValue, Mobile: shadowValue };
          setFirstDesktop(true);
          setFirstTablet(true);
          localStorage.setItem('firstTablet', true);
      } else {
          updatedAttributes.Desktop = shadowValue;
      }
    } else if (deviceView === 'Tablet') {
      if (isTabletFirstRun) {
          updatedAttributes = { ...dropShadow.value, Tablet: shadowValue, Mobile: shadowValue };
          setFirstTablet(true);
          setFirstDesktop(false);
          localStorage.removeItem('firstTablet');
      } else {
          updatedAttributes.Tablet = shadowValue;
      }
    } 
    else if (deviceView === 'Mobile') {
      updatedAttributes.Mobile = shadowValue;
      setFirstDesktop(false);
      setFirstTablet(false);
      localStorage.removeItem('firstTablet');
    }
     // setAttributes({ [dropShadow.key]: updatedAttributes });
    onChange(dropShadow.key,updatedAttributes);
  };
  
  const handelShadowValueChanges = () => {
    shadowValueChange(fixBoxShadowValue);
  }

  const eyePickColor = async () => {
    if ('EyeDropper' in window) {
      try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open();
        setColor(result.sRGBHex);
      } catch (err) {
        console.error('EyeDropper cancelled or failed:', err);
      }
    } else {
      alert('EyeDropper API is not supported in this browser.');
    }
  }

  return(
    <VStack spacing="20px"
            style={{background:'#fff',
              whiteSpace: 'normal',
              width: '280px',
              padding: "20px"
            }}
    >
      <Text><b>{label}</b></Text>

      <Text>
        <Icon className="vb-eyedrop" icon={ brush } onClick={eyePickColor} title="eyeDrop"/>
        <ColorPalette
          __experimentalIsRenderedInSidebar
          clearable={false}
          value={color}
          onChange={ ( color ) => setColor( color ) }
        />
      </Text>

      <Text>
        <Grid
          alignment="bottom"
          columns={5}
          gap={2}
        >
        <Text>
          <button
            style={{
              background: 'linear-gradient(-45deg, #0000 48%, #ddd 0, #ddd 52%, #0000 0)',
              border: "1px solid #e0e0e0",
              height: 26,
              position: 'relative',
              width: 26,
              cursor: "pointer",
              alignItems: 'center',
              padding:0,
              transform: 'scale(1)',
              transition: 'transform .1s ease',
              willChange: 'transform',
            }}
            onClick={() => {setElevationCheck('none')}}
          >
            {elevationCheck==='none' && <span className='vb-box-shadow-check'><Icon icon={check} /></span>}
          </button>
        </Text>
      <Text>
<button
style={{
  background: 'transparent',
  border: "1px solid #e0e0e0",
  height: 26,
  position: 'relative',
  width: 26,
  cursor: "pointer",
 // boxShadow: `${xpostion} ${ypostion} ${blur} ${validSpread} ${color}`,

  boxShadow: fixBoxShadowValue

}}
onClick={() => {setElevationCheck('default')}}

>
<Icon icon={shadow} style={{fill:'#c7c1c1',marginLeft:'-6px'}}/>
{elevationCheck==='default' && <span className='vb-box-shadow-check' style={{position:'absolute',left: '-1px', bottom:'-4px'}}><Icon icon={check} /></span>}

</button>
</Text>


</Grid>
      </Text> 

      <Text>
        <ToggleGroupControl
          __next40pxDefaultSize
          __nextHasNoMarginBottom
          isBlock
          value={isInset}
          onChange={(newset) => {setIsInset(newset)}}
        >
          <ToggleGroupControlOption
            label="Outset"
            value="outset"
          />
          <ToggleGroupControlOption
            label="Inset"
            value="inset"
          />
        </ToggleGroupControl>
      </Text>

      <Text>
        <Grid
          alignment="bottom"
          columns={2}
          gap={2}
        >
          <Text>
            <UnitControl
              __next40pxDefaultSize
              label="X Position"
              onChange={ ( pos ) => setXPostion( pos ) }
              onDrag={() => {}}
              onDragEnd={() => {}}
              onDragStart={() => {}}
              onUnitChange={() => {}}
              onValidate={() => {}}
              value={xpostion}
            />
          </Text>

          <Text>
            <UnitControl
              __next40pxDefaultSize
              label="Y Position"
              onChange={ ( pos ) => setYPostion( pos ) }
              onDrag={() => {}}
              onDragEnd={() => {}}
              onDragStart={() => {}}
              onUnitChange={() => {}}
              onValidate={() => {}}
              value={ypostion}
            />
          </Text>

          <Text>
            <UnitControl
              __next40pxDefaultSize
              label="Blur"
              onChange={ ( newvalue ) => setBlur( newvalue ) }
              onDrag={() => {}}
              onDragEnd={() => {}}
              onDragStart={() => {}}
              onUnitChange={() => {}}
              onValidate={() => {}}
              value={blur}
            />
          </Text>

          <Text>
            <UnitControl
              __next40pxDefaultSize
              label="Spread"
              onChange={ ( newvalue ) => setSpread( newvalue ) }
              onDrag={() => {}}
              onDragEnd={() => {}}
              onDragStart={() => {}}
              onUnitChange={() => {}}
              onValidate={() => {}}
              value={spread}
            />
          </Text>

        </Grid>
    </Text>

    </VStack>
  );}